// ThemeStatusIndicator.tsx
type ThemeStatusIndicatorProps = {
  status: 'active' | 'inactive' | 'pending' | 'verified' | 'enabled' | 'disabled';
  label?: string;
  size?: 'sm' | 'md';
};

const statusColors = {
  active: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  inactive: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-400',
  pending: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400',
  verified: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  enabled: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  disabled: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-400'
};

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2 py-1 text-xs'
};

export const ThemeStatusIndicator: React.FC<ThemeStatusIndicatorProps> = ({ 
  status, 
  label,
  size = 'md'
}) => {
  return (
    <span className={`inline-flex rounded-full ${statusColors[status]} ${sizeClasses[size]}`}>
      {label || status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};